<mat-sidenav-container>
  <mat-sidenav #sidenav [mode]="'over'">
    <app-sidenav-content></app-sidenav-content>
  </mat-sidenav>

  <mat-sidenav-content>
    <app-header
      (isHandsetPortraitStatus)="isHandsetPortraitStatus($event)"
      (openSideNav)="sidenav.toggle()"
    ></app-header>
    <div class="sggs-dashboard-content">
      <div class="small-carousel carousel-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="title-banner-wrapper {{bannerClass}}" style="background-image: url('assets/images/{{bannerImage}}');">
          <div class="bani-title">
            {{ activeLanguageTranslations?.dictionaryTitle }}
          </div>
        </div>
      </div>
      <div class="padded-content-wrapper" [class.is-mobile]="isHandsetPortrait">
        <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.dictionaryTitle }}</div>
        <div class="static-content-paragraph">
          <!-- <b> {{ activeLanguageTranslations?.sggsProject }} </b> <br />
          {{ activeLanguageTranslations?.subTagLine }} -->
        </div>

        <!-- <div class="static-content-heading-wrapper">{{ activeLanguageTranslations?.theVision }}</div> -->
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphOne  }}
        </div>

         <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphTwo  }}
        </div>
        <div class="static-content-paragraph">
          {{ activeLanguageTranslations?.visionParagraphThree  }}
        </div>

        <div class="static-content-paragraph">
          <p><a class="know-more" href="https://dev-sikhridictionary-webapp.azurewebsites.net/" target="_blank">{{ "know_more" | translate }}</a></p>
        </div>
        

       
      </div>
       <app-footer [isHandsetPortrait]="isHandsetPortrait"></app-footer>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
